import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorComponent from "../Components/Error/ErrorComponent";
import Navbar from "../Components/Navbar/Navbar";
import Contact from "../Components/Pages/Contact/Contact";
import CV from "../Components/Pages/CV/CV";
import Home from "../Components/Pages/Home/Home";
import Project from "../Components/Pages/Projects/Project/Project";
import Projects from "../Components/Pages/Projects/Projects";

const router = createBrowserRouter([
	{ path: "/", element: <Home />, errorElement: <ErrorComponent /> },
	{
		path: "/projects",
		element: <Projects />,
		errorElement: <ErrorComponent />,
	},
	{
		path: "/projects/:id",
		element: <Project />,
		errorElement: <ErrorComponent />,
	},
	{ path: "/contact", element: <Contact />, errorElement: <ErrorComponent /> },
	{ path: "/cv", element: <CV />, errorElement: <ErrorComponent /> },
]);
const Routes = () => {
	return <RouterProvider router={router} />;
};

export default Routes;
